//PROD
// const api = {
//     BASE_URL: "https://vumjbhw69h.execute-api.ap-south-1.amazonaws.com",
//     x_api_key: "2gsYbi3yKC2lvXxp25o9z4w39DL6RIJS299E5j4N",
//     authorizationToken: "ix7L30Ml68S33Vme"
// }

//UAT
const api = {
    BASE_URL: "https://bzpai382jl.execute-api.ap-south-1.amazonaws.com",
    x_api_key: "P9RbUlZxvR1KvSjazDt4xabz7oto3Fg52XYmJ0jT",
    authorizationToken: "ca8EQt07hBs1X9gM"
}

//demo
// const api = {
//     BASE_URL: "https://ubr8htfrxj.execute-api.ap-south-1.amazonaws.com/default/ainxt_signature-validation_service",
//     x_api_key: "KFMHLbn1ph7rJUmoQaUCu3MybLXVvGP28els57p9",
//     authorizationToken: "vH24IILXH3wR4kRY"
// }



export default api;